import type {QueryClient} from "@tanstack/react-query";
import {qk} from "@queries/keys";

interface InvalidateAfterRedeemParams {
    queryClient: QueryClient;
    productId: string;
}

export async function invalidateAfterRedeem({queryClient, productId}: InvalidateAfterRedeemParams) {

    const tasks: Array<Promise<unknown>> = [];

    tasks.push(queryClient.invalidateQueries({queryKey: qk.wallet()}));
    tasks.push(queryClient.invalidateQueries({queryKey: ["transactions"]}));
    tasks.push(queryClient.invalidateQueries({queryKey: ["redemptions"]}));
    tasks.push(queryClient.invalidateQueries({queryKey: qk.product(productId)}));

    await Promise.all(tasks);

    await queryClient.refetchQueries({queryKey: qk.wallet(), type: "all"});
    await queryClient.refetchQueries({queryKey: ["transactions"], type: "all"});
    await queryClient.refetchQueries({queryKey: ["redemptions"], type: "all"});
    await queryClient.refetchQueries({queryKey: qk.product(productId), type: "all"});
}

export async function invalidateAfterInvoiceUpload({queryClient}: { queryClient: QueryClient }) {
    await queryClient.invalidateQueries({queryKey: ["invoices"]});
    await queryClient.refetchQueries({queryKey: ["invoices"], type: "all"});
}